/**
 * Return Form Element with given params
 * @param data - data required for form like fields, url, method
 */
export const createForm = (data: {
    method: string;
    url: string;
    params?: { [key in string]: string };
}): HTMLFormElement => {
    const form = document.createElement("form");
    form.style.display = "none"; // ensure that the form is hidden from the user
    form.setAttribute("method", data.method);
    form.setAttribute("action", data.url);

    if (data.method === "POST") {
        const params = data.params || {};
        Object.keys(params).forEach(key => {
            const value = params[key];
            const field = document.createElement("input");
            field.setAttribute("type", "hidden");
            field.setAttribute("name", key);
            field.setAttribute("value", value);
            form.appendChild(field);
        });
    }

    document.body.appendChild(form);
    return form;
};

export const createAndSubmitForm = (data: { url: string; params?: { [key in string]: string } }): void => {
    const form = createForm({ ...data, method: "POST" });
    form.submit();
};
